import { render } from "solid-js/web";
import { App } from "./App.tsx";
import { MountPointNotFoundError } from "./errors/index.ts";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new MountPointNotFoundError("#root");

render(() => <App />, root);
